<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Users List</h2> 
            </div>
        </div>

        <div class="row mt-lg-2">
            <div class="col-12 col-md-10">
            <form class="form" @submit.prevent="submit">
                <div class="form-row">
                <div class="col-12 col-md-3">
                    <div class="form-group" v-if="currentUser.can('admin')">
                        <label for="force">Force</label>
                        <select class="custom-select " id="force" name="force" v-model="params.force_id" :disabled="loading">
                            <option value="">--- All ---</option>
                            <option v-for="force in forces" :key="force.id" :value="force.id">
                                {{ force.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-12 col-md-3">
                    <div class="form-group ">
                        <label for="lpa" >LPA</label>
                        <select class="custom-select " id="lpa" name="lpa" :disabled="lpas.length === 0 || loading" v-model="params.lpa_id">
                            <option value="">--- All ---</option>
                            <option v-for="lpa in lpas" :key="lpa.id" :value="lpa.id">
                                {{ lpa.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-12 col-md-3">
                    <div class="form-group">
                        <label for="search" >Search</label>
                        <input type="text" class="form-control" id="search" 
                            v-model="params.term"
                            :disabled="loading">
                    </div>
                </div>
                <div class="col-12 col-md-2">
                    <div class="form-group">
                        <label for="Search" class="text-white d-none d-md-block">Search</label>
                        <button type="submit" class="btn btn-primary"
                            :disabled="loading">Search <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span></button>
                        </div>
                    </div>
                </div>
            </form>
            </div>
            <div class="col-4 offset-8 col-md-1 text-right offset-md-1">
                <select class="custom-select" id="results_count" name="results_count" v-model="params.per_page" @change.prevent="changePerPage">
                    <option :value="10">10</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                    <option :value="-1">ALL</option>
                </select> 
            </div> 
        </div>

        <div class="row justify-content-center mt-4">
            <table class="table table-hover table-responsive-md">
                <thead>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Surname</th>
                        <th scope="col">Email</th>
                        <th scope="col">Collar</th>
                        <th scope="col">Tel. Ext</th>
                        <th scope="col">Rank</th>
                        <th scope="col">Default LPA</th>
                        <th scope="col">Force</th>
                        <th scope="col"></th>
                    </tr>
                </thead> 
                <tbody>
                    <tr v-for="user in users" :key="user.id" :class="{'table-warning': user.awaiting_authorisation}">
                        <td>{{user.first_name}}</td> 
                        <td>{{user.last_name}}</td> 
                        <td>{{user.email}}</td> 
                        <td>{{user.collar}}</td>
                        <td>{{user.telephone_extension}}</td>
                        <td>{{user.rank.name}}</td>
                        <td>{{exists(user.lpa, 'name')}}</td>
                        <td>{{exists(user.force, 'name')}}</td> 
                        <td>
                            <router-link :to="{name: 'users.edit', params:{id: user.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Edit'">
                                <img src="../../../assets/svgs/Edit-Icon.svg">
                            </router-link>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="9" v-if="users.length == 0">
                            No Users found.
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination :data="paginator" :limit="2" @pagination-change-page="search"></pagination>
        </div>
    </div>
</template>

<script>
import CurrentUser from '../../../mixins/CurrentUser';
import pagination from "laravel-vue-pagination";

export default {
    data() {
        return {
            loadingParams: false,
            params: {
                per_page: 10,
                force_id: '',
                lpa_id: '',
                term: '',
                page: 1,
            },
        }
    },

    mixins: [CurrentUser],
    components: {pagination},

    mounted() {
        this.loadingParams = true;
        if (window._.isEmpty(this.$route.query)) {
            this.params.force_id = this.currentUser.force_id;
            this.params.lpa_id = this.currentUser.default_lpa_id ?? "";
        } else {
            this.params = {...this.params, ...this.$route.query};

            this.params.per_page = this.params.per_page != '' ? parseInt(this.params.per_page) : '';
            this.params.lpa_id = this.params.lpa_id != '' ? parseInt(this.params.lpa_id) : '';
            this.params.force_id = this.params.force_id != '' ? parseInt(this.params.force_id) : '';
            this.params.page = this.params.page != '' ? parseInt(this.params.page) : '';
        }

        this.$nextTick(function() {
            this.loadingParams = false;
        });

        this.$store.dispatch('users/search', this.params);
    },
    
    watch: {
        forceId: function () {
            if (!this.loadingParams) {
                this.params.lpa_id = '';
            }
        },
    },

    methods: {
        exists(lpa, key){
            return (lpa !== undefined && lpa !== null) ? lpa[key] : '';
        },

        submit(){
            this.search(1);
        },

        changePerPage: function () {
            this.search(1)
        },
        
        search(page){
            this.params.page = page;
            this.$router.push({name: 'users.index', query: this.params}).catch(()=>{});
            this.$store.dispatch('users/search', this.params);
        },
    },

    computed: {
        forceId: function () {
            return this.params.force_id;
        },

        users: function () {
            return this.$store.state.users.data;
        },

        forces: function () {
            return this.$store.state.forces.data;
        },

        lpas: function () {
            if (this.params.force_id === "") {
                return [];
            }

            const force = this.forces.filter(force => force.id === parseInt(this.params.force_id))[0];

            if (force === undefined) {
                return []
            }

            return force.lpas ?? [];
        },

        paginator: function () {
            return this.$store.state.users.paginator;
        },

        loading: function () {
            return this.$store.state.users.loading;
        },
        
    }
}
</script>